import _ from 'lodash';
import Vue from 'vue';

export const state = () => ({
  outcomes: {},
})

export const mutations = {
 
}